export default __webpack_public_path__ + "6ae354e40762d58654bfdea042c6ebc0.glb";